import assets from 'assets/icons/sprites.svg';

interface RiyalIconProps {
	color?: string;
	size?: number | string;
	style?: React.CSSProperties;
}

function Riyal({ color, style, size = 15 }: RiyalIconProps) {
	return (
		<svg style={{ fill: color ? color : undefined,  maxWidth: size, height: size, ...style }}>
			<use href={assets + '#riyal'}></use>
		</svg>
	);
}

export default Riyal;
